import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Section({ title, children }) {
  return (
    <section className="rounded-3xl border border-white/70 bg-white/80 p-6 shadow-[0_14px_40px_rgba(15,23,42,0.05)] backdrop-blur-sm sm:p-7">
      <h2 className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl">
        {title}
      </h2>
      <div className="mt-4 space-y-4 text-[15px] leading-8 text-slate-600">
        {children}
      </div>
    </section>
  );
}

export default function PolitykaPrywatnosci() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#f6fbfa] text-slate-800">
      {/* Tło spójne z loginem */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(167,243,208,0.24),_transparent_28%),radial-gradient(circle_at_top_right,_rgba(253,224,171,0.22),_transparent_24%),radial-gradient(circle_at_bottom_left,_rgba(186,230,253,0.18),_transparent_28%),linear-gradient(180deg,#f8fcfb_0%,#eef8f6_100%)]" />
        <div className="absolute -top-20 -left-16 h-56 w-56 rounded-full bg-emerald-200/35 blur-3xl" />
        <div className="absolute top-[12%] right-[8%] h-32 w-32 rounded-full bg-amber-200/30 blur-2xl" />
        <div className="absolute bottom-[8%] right-[6%] h-64 w-64 rounded-full bg-teal-200/20 blur-3xl" />
        <div className="absolute left-[8%] top-[44%] h-[1px] w-[36%] rounded-full bg-emerald-200/70" />
        <div className="absolute left-[10%] top-[47%] h-[1px] w-[28%] rounded-full bg-sky-200/60" />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8 lg:py-10">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <Link
            to="/login"
            className="inline-flex items-center gap-2 rounded-full border border-white/70 bg-white/80 px-4 py-2 text-sm font-medium text-slate-600 shadow-[0_8px_20px_rgba(15,23,42,0.05)] backdrop-blur-sm transition-all duration-200 hover:-translate-y-0.5 hover:text-emerald-700"
          >
            ← Powrót
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.05 }}
          className="mt-6 overflow-hidden rounded-[34px] border border-white/70 bg-[linear-gradient(135deg,rgba(255,255,255,0.88)_0%,rgba(236,253,245,0.78)_38%,rgba(255,247,237,0.76)_100%)] shadow-[0_20px_60px_rgba(15,23,42,0.08)] backdrop-blur-sm"
        >
          <div className="border-b border-white/60 px-6 py-8 sm:px-8 sm:py-10">
            <div className="max-w-3xl">
              <div className="mb-3 inline-flex rounded-full border border-emerald-100 bg-white/75 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-emerald-700/80">
                Bezpieczeństwo danych
              </div>

              <h1 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
                Polityka prywatności
              </h1>

              <p className="mt-4 max-w-2xl text-base leading-7 text-slate-600">
                Informacje dotyczące zasad przetwarzania danych w ramach strony do
                rozliczeń klasy. Dokument został przygotowany w prostej i czytelnej
                formie, tak aby każdy mógł łatwo sprawdzić, jakie dane są używane i w jakim celu.
              </p>
            </div>
          </div>

          <div className="space-y-6 px-4 py-6 sm:px-6 sm:py-8 lg:px-8">
            <Section title="1. Informacje ogólne">
              <p>
                Niniejsza strona została stworzona w celu usprawnienia rozliczeń
                finansowych klasy oraz zapewnienia przejrzystości w zakresie
                wpłat, wydatków i dostępnych środków.
              </p>
              <p>
                Administratorem danych jest osoba prowadząca rozliczenia klasy
                (skarbnik).
              </p>
            </Section>

            <Section title="2. Zakres przetwarzanych danych">
              <p>W ramach działania strony przetwarzane są wyłącznie podstawowe dane:</p>
              <ul className="list-disc space-y-2 pl-6">
                <li>adres e-mail użytkownika</li>
              </ul>
              <p>Dane te wykorzystywane są wyłącznie w celu:</p>
              <ul className="list-disc space-y-2 pl-6">
                <li>umożliwienia dostępu do systemu,</li>
                <li>
                  ograniczenia dostępu do danych wyłącznie do osób uprawnionych
                  (rodziców lub opiekunów z danej klasy).
                </li>
              </ul>
              <p>
                Strona nie gromadzi dodatkowych danych osobowych w celach
                marketingowych ani nie udostępnia ich osobom trzecim.
              </p>
            </Section>

            <Section title="3. Cel i podstawa przetwarzania danych">
              <p>
                Dane przetwarzane są w celu organizacji rozliczeń finansowych klasy
                oraz zapewnienia dostępu do informacji o stanie środków.
              </p>
              <p>
                Podstawą przetwarzania danych jest uzasadniony interes polegający
                na prowadzeniu i organizacji rozliczeń klasowych.
              </p>
            </Section>

            <Section title="4. Dostęp do danych">
              <p>
                Dostęp do danych ma wyłącznie administrator (skarbnik).
              </p>
              <p>
                Dane nie są udostępniane innym użytkownikom w sposób umożliwiający
                identyfikację wpłat konkretnych osób.
              </p>
              <p>
                Użytkownicy mają dostęp jedynie do zbiorczych informacji finansowych,
                takich jak suma wpłat, wydatki i saldo.
              </p>
            </Section>

            <Section title="5. Przechowywanie danych">
              <p>
                Dane przechowywane są w systemie Supabase z wykorzystaniem
                standardowych zabezpieczeń.
              </p>
              <p>
                Połączenie ze stroną jest szyfrowane (HTTPS).
              </p>
              <p>
                Dane przechowywane są wyłącznie przez okres korzystania z systemu
                lub do momentu zgłoszenia żądania ich usunięcia.
              </p>
            </Section>

            <Section title="6. Prawa użytkownika">
              <p>Każda osoba ma prawo do:</p>
              <ul className="list-disc space-y-2 pl-6">
                <li>wglądu do swoich danych,</li>
                <li>żądania ich poprawienia,</li>
                <li>żądania usunięcia danych z systemu.</li>
              </ul>
              <p>
                W celu realizacji tych praw należy skontaktować się z administratorem.
              </p>
            </Section>

            <Section title="7. Dobrowolność korzystania">
              <p>
                Korzystanie ze strony jest dobrowolne.
              </p>
              <p>
                Osoby, które nie chcą korzystać z systemu, mogą nadal otrzymywać
                rozliczenia w formie tradycyjnej, np. w formie plików PDF.
              </p>
            </Section>

            <Section title="8. Zmiany polityki prywatności">
              <p>
                Polityka prywatności może być aktualizowana w przypadku zmian
                w funkcjonowaniu strony.
              </p>
            </Section>

            <Section title="9. Kontakt">
              <p>
                W sprawach związanych z danymi osobowymi należy kontaktować się
                bezpośrednio ze skarbnikiem klasy.
              </p>
            </Section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}